/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth/core/Auth'
import {Languages} from './Languages'
import {defaultProfileImage} from '../../../../app/modules/core'

const HeaderUserMenu = () => {
  const {currentUser, logout} = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              src={
                currentUser?.employee_profile_pic
                  ? currentUser?.employee_profile_pic
                  : defaultProfileImage
              }
              alt='img'
            />
          </div>

          <div className='d-flex flex-column default-cursor'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser && currentUser?.first_name} {currentUser?.last_name}
            </div>
            <span className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser && currentUser?.email}
            </span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/employees/my-info/information'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={'/employees/my-info/projects'} className='menu-link px-5'>
          My Projects
        </Link>
      </div>
      {/* <Languages /> */}
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
